<mapfre-header [isGuest]="true"></mapfre-header>
<div class="container mapfre-content">
  <mapfre-card additionalClasses="signup guest-payment-container">
    <div class="row text-center">
      <div class="col">
        <div class="header-icon full-icon">
          <img src="./assets/img/images/icon-warning-64-black.svg" width="64" height="64" alt="warning icon" />
        </div>
        <h1 class="title-copy">This link has expired</h1>
      </div>
    </div>
    <div class="rp-disabled-content text-center">
      <p class="rp-support-text">
        Our team is here to help.<br />
        Support is available Monday&#8211;Friday<br class="rp-br-desktop" />
        from 8:00 a.m. to 6:00 p.m. PST <br class="rp-br-mobile" />and Saturday
        from 6:00 a.m. to <br class="rp-br-mobile" /> 12:00 p.m. PST.
      </p>
      <div class="rp-cta-section">
        <a href="tel:12068778313" class="rp-call-btn">CALL 1-206-877-8313</a>
      </div>
      <div class="rp-links-section">
        <p class="rp-billing-link">
          For additional billing &amp; payment options,<br />
          please log into <a routerLink="/" class="rp-anchor-link">My account</a>
        </p>
        <div class="rp-create-account">
          <p>No online account yet?</p>
          <a routerLink="/signup" class="rp-anchor-link">Create your account</a>
        </div>
        <p class="rp-benefits-text">
          By logging in, you can pay with a checking account, set up Autopay, go paperless,
          access policy details, manage claims, and much more
        </p>
      </div>
    </div>
  </mapfre-card>
</div>
